import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("流向")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Record = _resolveComponent("Record")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, { gutter: 5 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 20,
          sm: 6,
          class: "mb15"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.jsm,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jsm) = $event)),
              placeholder: "单位编号/单位名称/单位简称",
              size: "small"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 4,
          sm: 4,
          class: "mb15"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $setup.search
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          id: "out-table",
          data: _ctx.goodslist.slice((_ctx.currentPage-1)*_ctx.pagesize,_ctx.currentPage*_ctx.pagesize),
          border: "",
          style: {"width":"100%"},
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "dwbh",
              label: "单位编号",
              width: "90px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "dwm",
              label: "单位名称",
              width: "400px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "jsm",
              label: "单位简称",
              width: "200px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cz",
              label: "购销类别",
              width: "150px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "ywybh",
              label: "业务员",
              width: "150px"
            }),
            ($setup.getUserInfos.userName!=='admin')
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "操作",
                  width: "50px"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      size: "mini",
                      type: "text",
                      onClick: ($event: any) => ($setup.onGoDetailsClick(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_el_pagination, {
        currentPage: _ctx.currentPage,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
        "page-size": _ctx.pagesize,
        "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagesize) = $event)),
        "page-sizes": [10, 50, 100, 200],
        small: true,
        background: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total,
        onCurrentChange: $setup.handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "total", "onCurrentChange"])
    ]),
    _createVNode(_component_Record, { ref: "RecordRef" }, null, 512)
  ], 512)), [
    [_directive_loading, _ctx.loading]
  ])
}